import styled from 'styled-components';
import {
  mediaQueries,
  themeColors,
  themeSizes,
} from '../../../styles/globalStyleVars';
import type { AlertInterface } from '../../../interfaces/AlertInterface';
import { useAlertsStore } from '../../../stores/alertsStore';
import { AlertsBannerItem } from './AlertsBannerItem';
import { IconX } from '@tabler/icons-react';
import { IconButton } from '@cfa/react-core';

type AlertsBannerProps = {
  alertsAndOutages: AlertInterface[];
  setAlertsDrawerOpen: () => void;
  setAlertChildCaseOpen: (val: AlertInterface) => void;
};

const BannerContainer = styled.div`
  background-color: ${themeColors.notificationBackgroundColor};
  margin: 0;
  justify-content: center;
  display: flex;
  position: static;
  z-index: 5;
  top: 74px;

  ${mediaQueries.sm_up} {
    position: -webkit-sticky;
    position: sticky;
  }
`;

const BannerWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  padding: ${themeSizes.md};
  ${mediaQueries.sm_up} {
    padding: ${themeSizes.md} 36px;
  }
  ${mediaQueries.md_up} {
    padding: ${themeSizes.md} ${themeSizes.xl};
  }
  ${mediaQueries.lg_up} {
    padding: ${themeSizes.md} 46px;
  }
`;

const AlertsWrapper = styled.div`
  > div:nth-child(2) {
    margin-top: ${themeSizes.md};
    ${mediaQueries.sm_up} {
      margin-top: ${themeSizes.xl};
    }
  }
`;

export const AlertsBanner = ({
  alertsAndOutages,
  setAlertsDrawerOpen,
  setAlertChildCaseOpen,
}: AlertsBannerProps) => {
  const { setAllAlertsDismissed } = useAlertsStore();

  const handleCloseBanner = () => {
    setAllAlertsDismissed();
  };

  return (
    <BannerContainer data-testid='alerts-page-banner'>
      <BannerWrapper>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            aria-label='Close alerts banner'
            onPress={() => handleCloseBanner()}
            style={{
              width: 'auto',
              padding: `${themeSizes.xs} 0`,
            }}
            data-testid='alerts-banner-close-btn'
          >
            <IconX color={themeColors.colorGray_6} />
          </IconButton>
        </div>
        <AlertsWrapper data-testid='alerts-banner-items'>
          {alertsAndOutages.map((alert, index) => (
            <AlertsBannerItem
              key={index}
              alert={alert}
              setAlertsDrawerOpen={setAlertsDrawerOpen}
              setAlertChildCaseOpen={setAlertChildCaseOpen}
            />
          ))}
        </AlertsWrapper>
      </BannerWrapper>
    </BannerContainer>
  );
};
